// extracted by mini-css-extract-plugin
export var container = "_3y-0";
export var disabled = "_3y-4";
export var fullWidth = "_3y-3";
export var lined = "_3y-1";
export var selected = "_3y-5";
export var tab = "_3y-2";